import React from 'react'
import { SearchIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@/shared/components/ui/empty'
import { cn } from '@/shared/lib/utils'

type Props = {
	className?: string
	imgClassName?: string
	title?: string
	subtitle?: string
	children?: React.ReactNode
}

export default function NoData({
	className,
	title,
	subtitle,
	children,
	imgClassName,
}: Props) {
	const { t } = useTranslation()

	return (
		<Empty data-testid='no-data' className={cn('m-auto', className)}>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<SearchIcon className='text-muted-foreground' />
				</EmptyMedia>
				<EmptyTitle>{title ?? t('no_data')}</EmptyTitle>
				{subtitle && <EmptyDescription>{subtitle}</EmptyDescription>}
			</EmptyHeader>
			{children && <EmptyContent>{children}</EmptyContent>}
		</Empty>
	)
}
